<template>
  <div>
<!--文章-->
    <div v-if="artType==0" >
      <!--头部-->
      <shareHead @openApp="btnOpenApp1"></shareHead>
      <!--中部-->
      <div class="body">
        <div class="offsetHead"></div>
        <!--标题-->
        <div class="title">{{title}}</div>
        <!--出处-->
        <shareOriginal :isOriginal="isOriginal" :original="original" :author="author" :showTime="showTime"></shareOriginal>
        <!--文章具体内容-->
        <p><span v-html="htmlContext"> </span></p>
        <!--阅读数-->
        <div class="readNum">{{ readNum }} 阅读</div>
<!--        <div class="body_bottom"></div>-->
      </div>

      <!--    推荐信息-->
      <recommend :dailies="dailies"></recommend>
      <!--脚部-->
      <foot :commentNum="commentNum" :collectionNum="collectionNum" :goodNum="goodNum" @openApp="btnOpenApp"></foot>
    </div>
<!--视频-->
    <div v-else-if="artType==1" >
      <!--视频播放区-->
      <div class="video_play dw">
<!--        <mgVideo :videoUrl=contentVideo :posterUrl=videoPoster></mgVideo>-->
<!--        <mediaPlayer class="mediaPlayer" :sourceUrl="contentVideo" :posterUrl="videoPoster"></mediaPlayer>-->
        <myMediaPlayer class="mediaPlayer"
                       ref="myVideo2"
                       :isLogo="true"
                       :isLookBack="false"
                       :src="contentVideo"
                       :poster="videoPoster">
        </myMediaPlayer>
      </div>

      <div class="body">
        <!--标题-->
        <div class="title">{{title}}</div>
        <!--出处-->
        <shareOriginal :isOriginal="isOriginal" :original="original" :author="author" :showTime="showTime"></shareOriginal>
      </div>
      <!--中部-->
      <div class="video_open_app dw" @click="btnOpenApp">打开“嗨科普”观看，清晰又流畅</div>
      <!--    推荐信息-->
      <recommend :dailies="dailies"></recommend>
      <!--脚部-->
      <foot :commentNum="commentNum" :collectionNum="collectionNum" :goodNum="goodNum" @openApp="btnOpenApp"></foot>
    </div>
<!--其他-->
    <div v-else>
      <!--头部-->
      <shareHead @openApp="btnOpenApp"></shareHead>
      <!--内容区-->
      <div class="loadErr" @click="tryAgain">加载失败 id={{dailyId}}</div>
      <!--    推荐信息-->
      <recommend :dailies="dailies"></recommend>
      <!--脚部-->
      <foot :commentNum="commentNum" :collectionNum="collectionNum" :goodNum="goodNum" @openApp="btnOpenApp"></foot>
    </div>
  </div>
</template>

<script>
import {dailyApi, getDaily} from "../../js/shareApp/daily";
import {Toast} from "vant";
// import mgVideo from "../../components/content/mgVideo";
import foot from "./foot";
import shareHead from "./shareHead";
import shareOriginal from "./shareOriginal";
import {baseConfig} from "../../network/baseConfig";
import {actUtil} from "../../js/activity/util";
// import mediaPlayer from "../../components/common/mediaPlayer/mediaPlayer";
// import homeRecommend from "../ recommend/homeRecommend";
import recommend from "../ recommend/recommend";
import myMediaPlayer from "../../components/myMediaPlayer/myMediaPlayer";


export default {
  name: "shareDaily",
  components:{
    // mediaPlayer,
    foot,
    shareHead,
    shareOriginal,
    recommend,
    myMediaPlayer,
    // homeRecommend
  },
  data(){
    return {
      //获取单条动态ID
      dailyId: '',
      // context: '',
      contextUrl: '',
      htmlContext: '',

      title: '',
      isOriginal: 0, //是否原创  (boolean)
      original: '',  //出处  (string)
      author: '',    //作者

      artType: 0,   //动态类型:0 文章 1 视频   (smallInteger)


      videoPoster: '',
      contentVideo: '',

      showTime: '',
      readNum: 0,

      commentNum: 0,       //评论数   (integer)
      goodNum: 0,          //点赞数   (integer)
      collectionNum: 0,    //收藏数   (integer)

      dailies: [],
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.params.dailyId) {
        console.log('触发事件内容'+this.$route.params.dailyId)
        if (this.$route.params.dailyId!=this.dailyId){
          window.location.reload()
        }
      }
    }
  },

  created() {
    console.log('shareApp create');
    //输入的参数
    console.log(this.$route.params)
    console.log(this.$route.query)
    this.dailyId = this.$route.params.dailyId
    this.loadData()
  },
  mounted() {
    // 切换页面时滚动条自动滚动到顶部
    window.scrollTo(0,0);
    console.log('shareDail mounted')
    // alert("new daily2")
  },
  methods:{
    getItem(daily){
      let obj = {}
      obj.id = daily.id
      obj.title = daily.title
      obj.type = daily.type   //动态类型:0 文章 1 视频   (smallInteger)

      obj.goodNum = daily.goodNum //点赞数   (integer)
      obj.commentNum = daily.commentNum //评论数   (integer)
      obj.collectionNum = daily.collectionNum //收藏数   (integer)

      obj.imageCount = daily.imageCount ////图片数   (integer)
      obj.contentImage = JSON.parse(daily.contentImage) //图片内容包括视频预览图片 json数组   (text)
      obj.contentVideo = daily.contentVideo //视频内容  (string)

      obj.time = actUtil.remainingTime(daily.time)   //发布时间  (bigInteger)
      return obj
    },
    tryAgain(){
      this.loadData()
    },
    loadData(){
      Toast.loading({
        duration: 5000, // 持续展示 toast
        forbidClick: true,
        message: '加载中...',
      });
      getDaily({'id': this.dailyId}).then(res=>{
        // console.log('获取单条动态成功');
        // console.log(res)
        this.title = res.daily.title
        this.isOriginal = res.daily.isOriginal
        this.original = res.daily.original
        this.artType = res.daily.type
        this.commentNum = res.daily.commentNum
        this.goodNum = res.daily.goodNum
        this.collectionNum = res.daily.collectionNum
        this.author = res.daily.author
        this.readNum = res.daily.readNum
        var time = res.daily.time
        this.showTime = actUtil.remainingTime(time)
        if(this.artType==0){
          // console.log(ctObj)
          var ctx = res.daily.contentText
          var ctObj = JSON.parse(ctx)
          this.contextUrl = ctObj.url
          this.getArt(this.contextUrl)
        }else{
          var ctArray = JSON.parse(res.daily.contentImage)
          this.contentVideo = res.daily.contentVideo
          this.videoPoster = ctArray[0]
        }

        //阅读动态
        dailyApi.readDaily({'id': this.dailyId}).then(res=>{
          console.log("========================readdaily")
          console.log(res)
          this.dailies.length = 0
          if(typeof res.recommend != "undefined") {
            for (let i=0; i<res.recommend.length; i++){
              let retObj = this.getItem(res.recommend[i].daily)
              if(retObj!=null){
                this.dailies.push(retObj)
              }
            }
          }

          console.log(this.dailies)

        }).catch(err=>{

        })
        Toast.clear()
      }).catch(err=>{
        Toast.clear()
        this.artType = 255
        console.log('获取单条动态失败 err***');
        console.log(err)
      })
    },
    getArt(url){
      var that = this
      let xhr = new XMLHttpRequest();
      xhr.open("get", url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (this.status == 200) {
          const reader = new FileReader();
          reader.onload = function () {
            // console.log(reader.result)
            that.htmlContext = reader.result
          };
          reader.readAsText(this.response);
        }
      };
      xhr.send();
    },
    btnOpenApp1(){

    },
    btnOpenApp(){
      // console.log('打开APP')
      // window.location.href = baseConfig.getAppInfo().href
      window.location.href = baseConfig.getAppInfo().href
    },
    // //剩余时间
    // remainingTime(artTime){
    //   var curData = new Date();
    //   var curTick = parseInt(curData.getTime())
    //   // console.log(utils.date('Y-m-d', artTime/1000))
    //   // console.log(utils.date('Y-m-d', curTick/1000))
    //   // console.log(artTime)
    //   // console.log(curTick)
    //
    //   if(curTick>artTime){
    //     var delT = curTick-artTime
    //     //分钟
    //     delT = delT/1000/60;
    //     // console.log(delT)
    //     var str=''
    //     //天
    //     if((delT/(24*60))>0){
    //       str=parseInt(delT/(24*60))
    //       str+='天前'
    //     }
    //     //小时
    //     else if((delT/(60))>0){
    //       str=parseInt(delT/(60))
    //       str+='小时前'
    //     }
    //     //分钟
    //     else{
    //       str=parseInt(delT)
    //       str+='分钟前'
    //     }
    //     return str
    //   }
    //   else{
    //     return '刚刚'
    //   }
    // }
  }
}
</script>

<style scoped>
.mediaPlayer{
  width: 100%;
  height: 568px;
  /*object-fit: cover;*/
}
.loadErr{
  height: 100vh;
  width: 100%;
  font-size: 40px;
  color: #b9b8b8;
  text-align: center;
  line-height: 100vh;
  /*background-color: #ead287;*/
}
.body{
  padding-top: 0px;
  margin-left: 45px;
  margin-right: 45px;
}
.offsetHead{
  width: 100%;
  height: 130px;
}
.body_bottom{
  height: 40px;
  width: 100%;
  /*background-color: #ee0a24;*/
}
.title{
  margin-bottom: 40px;
  font-size: 60px;
  color: #35303d;
  font-weight: bolder;
}

.readNum{
  position: relative;
  margin-bottom: 40px;
  width: 990px;
  height: 50px;
  /*background-color: #ead287;*/
  font-size: 40px;
  color: #b7b7b7;
  line-height: 40px;
}
.readNum{
  margin-top: 80px;
}

.dw{
  width: 1080px;
  margin: auto;
}

.video_play{
  height: 608px;
  background-color: #3c3d41;
  margin-bottom: 40px;
}

.video_open_app{
  margin-bottom: 40px;
  width: 760px;
  height: 80px;
  background-color: #fb391e;
  font-size: 40px;
  line-height: 80px;
  color: whitesmoke;
  text-align: center;
  letter-spacing: 2px;
  /*font-weight: bolder;*/
  border-radius: 10px;
}

</style>